module.exports = __webpack_public_path__ + "img/3000.5475ea3f.png";